import React from "react"
import { Link } from "gatsby"

import styled from "styled-components"

const StyledCategoryMenu = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 50px auto;
  display: flex;
  flex-direction: row;
`
const CategoryLink = styled(Link)`
  width: 25%;
  margin: 0 auto;
  text-align: center;
  font-size: 1rem;
  text-transform: capitalize;
`

const CategoryMenu = () => {
  return (
    <StyledCategoryMenu>
      <CategoryLink to="category/web">Web</CategoryLink>
      <CategoryLink to="category/bboy">Bboy</CategoryLink>
      <CategoryLink to="category/book">Book</CategoryLink>
      <CategoryLink to="category/thoughts">Thoughts</CategoryLink>
    </StyledCategoryMenu>
  )
}

export default CategoryMenu
